import type { UIComponentProps } from '../types/UI';
import { cn } from '../utils/classnames';

export type ListProps<T> = UIComponentProps & {
  renderComponent?: (data: T) => React.ReactNode;
  listItems: T[];
};

export const List = <T,>({ listItems, renderComponent, className }: ListProps<T>) => {
  return (
    <div className={cn(`flex flex-wrap gap-10`, className)}>
      {listItems.map((item, index) => {
        return <div key={index}>{renderComponent?.(item)}</div>;
      })}
    </div>
  );
};
